import { OrderDetailItem } from "@/lib/constants";
import Image from "next/image";
import { CURRENCY_OPTIONS } from "../Common/GlobalVars";
import { useAttributesStore } from "@/stores/useAttributesStore";
import { useEffect, useState } from "react";
import { useUserStore } from "@/stores/useUserStore";
import { useRouter } from "next/router";

interface OrderDetailProps {
  order: OrderDetailItem;
}

const OrderDetail = (props: OrderDetailProps) => {
  const { order } = props;
  const router = useRouter();
  const { userInfo, getUser } = useUserStore();
  const { attributes, getAttributes } = useAttributesStore();
  const [userData, setUserData] = useState(getUser());
  const [attributeData, setAttributeData] = useState(getAttributes());
  const [init, setInit] = useState(true);
  const [subtotal, setSubtotal] = useState(0);
  const [shippingFee, setShippingFee] = useState(0);

  const handlePayment = () => {
    const params = Buffer.from(encodeURIComponent("ssid=" + order.payment_link + "&oid=" + order.id), 'utf-8').toString('base64');
    const url = "/checkout?payment=" + params;

    router.push(url);
  }

  const render_product_attr = (attr_list: Array<number>) => {
    const display_attr_list = [];

    if (attr_list.length > 0) {
      for (var i = 0; i < attributeData.data.length; i++) {
        const filtered = attributeData.data[i].attribute_values.filter((attribute) => attr_list.some((value) => attribute.id === value)).sort((a, b) => (a.order === b.order) ? a.id - b.id : a.order - b.order);

        switch (attributeData.data[i].slug) {
          case "color":
            if (filtered.length > 0) {
              display_attr_list.push(attributeData.data[i].name + ": " + filtered[0].name);
            }
            break;

          case "size":
            if (filtered.length > 0) {
              display_attr_list.push(attributeData.data[i].name + ": " + filtered[0].name);
            }
            break;

          case "stage":
            if (filtered.length > 0) {
              display_attr_list.push(attributeData.data[i].name + ": " + filtered[0].name);
            }
            break;

          case "pattern":
            if (filtered.length > 0) {
              display_attr_list.push(attributeData.data[i].name + ": " + filtered[0].name);
            }
            break;

          case "gender":
            if (filtered.length > 0) {
              display_attr_list.push(attributeData.data[i].name + ": " + filtered[0].name);
            }
            break;

          case "flavour":
            if (filtered.length > 0) {
              display_attr_list.push(attributeData.data[i].name + ": " + filtered[0].name);
            }
            break;
        }
      }

      return display_attr_list.map((text, index) => {
        return (
          <p key={index}>{text}</p>
        )
      })
    }
  }

  useEffect(() => {
    const calculateSubtotalAndShippingFee = () => {
      let calculatedSubtotal = 0;
      let calculatedShippingFee = 0;
  
      order.order_shipments.forEach((shipment) => {
        calculatedShippingFee += shipment.delivery_price;
  
        shipment.shipment_lines.forEach((line) => {
          calculatedSubtotal += line.price * line.qty;
        });
      });
  
      setSubtotal(calculatedSubtotal);
      setShippingFee(calculatedShippingFee);
    };

    if (init) {
      calculateSubtotalAndShippingFee();
      setInit(false);
    }
  }, [init, order.order_shipments])
  

  const render_order_lines = () => {
    return order.order_shipments.map((shipment, index) => {
      return shipment.shipment_lines.map((line, index) => {
        return (
          <div className="flex items-center mb-6 md:mb-2" key={index}>
            <Image
              src={line.product.image}
              alt={line.product.name + " image"}
              width={90}
              height={90}
              quality={100}
              className="w-[78px] h-[78px] md:w-[90px] md:h-[90px]"
            />
            <div className="grid items-center w-full grid-cols-1 ml-6 md:grid-cols-3 gap-x-4">
              <div className="w-full col-span-3 md:col-span-2">
                <p className="text-sm text-[#2C3E2F] leading-6">{line.product.name}</p>
                <p className="text-xs text-[#2C3E2F] leading-6">{render_product_attr(line.product.attribute_value_list)}</p>
                <p className="text-xs text-[#2C3E2F] leading-6">Qty : {line.qty}</p>
              </div>
              <div className="w-full col-span-3 mt-2 md:col-span-1 md:mt-0">
                <p className="text-base text-[#2C3E2F] leading-6 text-left md:text-right font-medium">{process.env.NEXT_PUBLIC_CURRENCY}{(line.price * line.qty).toLocaleString("en-US", CURRENCY_OPTIONS)}</p>
              </div>
            </div>
          </div>
        )
      })
    })
  }

  return (
    <div className="p-6 rounded-lg shadow-[0_5px_25px_-5px_rgb(0,0,0,0.1)] mt-6 w-full">
      <div className="text-base font-bold flex justify-between">
        <p className="text-[#2C3E2F]">{order.order_number}</p>
        <p className="text-[#A6CAA6] capitalize">{order.status}</p>
      </div>
      <div className="my-4">
        {render_order_lines()}
      </div>
      <hr className="h-[1px] w-full bg-[#C6C6C6]" />
      <div className="flex justify-between text-base font-dmsans mt-6">
        <p className="text-[#BABABA]">Sub total</p>
        <p className="text-[#2C3E2F]">{process.env.NEXT_PUBLIC_CURRENCY}{subtotal.toLocaleString("en-US", CURRENCY_OPTIONS)}</p>
      </div>
      <div className="flex justify-between my-6 text-base font-dmsans">
        <p className="text-[#BABABA]">Shipping fee</p>
        <p className="text-[#2C3E2F]">{process.env.NEXT_PUBLIC_CURRENCY}{shippingFee.toLocaleString("en-US", CURRENCY_OPTIONS)}</p>
      </div>
      <hr className="h-[1px] w-full bg-[#C6C6C6]" />
      <div className="flex items-center justify-between mt-6">
        <p className="text-[#2C3E2F] text-base font-medium">Total</p>
        <p className="text-[#2C3E2F] text-xl font-bold">{process.env.NEXT_PUBLIC_CURRENCY_CODE} {order.amount_total.toLocaleString("en-US", CURRENCY_OPTIONS)}</p>
      </div>
      {order.status === "Not Paid Yet" && (
        <button
          className="w-full md:w-fit py-4 px-12 text-base font-medium text-white bg-[#A6CAA6] mt-4"
          onClick={handlePayment}
        >
          Proceed to payment
        </button>
      )}
    </div>
  )
}

export default OrderDetail;
